import apiClient from "./client";

// fetch list of ZoneDto
export function fetchUsers() {
  return apiClient.get("/DropDown/GetUserDropDown").then((res) => res.data);
}

export function findingStatus() {
  return apiClient.get("/DropDown/GetFindingStatus").then((res) => res.data);
}

export function findingPriority() {
  return apiClient.get("/DropDown/GetFindingPriority").then((res) => res.data);
}

export function taskStatus() {
  return apiClient.get("/DropDown/GetTaskStatus").then((res) => res.data);
}

export function taskPriority() {
  return apiClient.get("/DropDown/GetTaskPriority").then((res) => res.data);
}
